
const theme = "dark"

const DarkTheme = {

        primary: '#f2f2f2',
        background: '#333333',
        card: '#444444',
        text: '#f2f2f2',
        border: '#f2f2f2',
        notification: '#f2f2f2',

};
const LightTheme = {

        primary: '#f2f2f2',
        background: '#f2f2f2',
        card: '#f2f2f2',
        text: '#333333',
        border: '#f2f2f2',
        notification: '#f2f2f2',
    }



export const themeColors =  {

    bg: '#262525', //Anjali Black
    fd:'rgba(255,255,255,0.18)', //White
    fg: '#9EBC80', //Middle Olive
    white: '#f2f2f2',
    text: '#f2f2f2',
    graywhite : '#f2f2f2',
    disabledText: '#6c6969',
    blue: '#3b5998',
    darkText: '#444444',
    lightAccent : '#EAF0D8', // Light Olive
    accent : '#465130', //Dark olive
    // accent : '#A872CA',
}





export const colors = {
    heading: 'text-gray-700',
    button: '#50C878'
}

export const categoryBG = {
    food: '#E1D3EE',
    commute: '#B0E3D3',
    shopping: '#EcFAD7',
    entertainment: '#ffdfdd',
    other: '#CAD309'
}

export const graphColors = [
    '#9EBC80', // secondary
    '#FFFFFF', // white
    '#465130', // primary
    '#d0d4c4', // light gray
    '#262525', // dark gray
    '#708454', // dark green
]